module.exports = __webpack_public_path__ + "6a5bade6bc65ebb616960bb9bc57e6e8.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/move/move-users-to-label.html
// module id = 2294
// module chunks = 0